module.exports = __webpack_public_path__ + "static/media/gq.fd80fdd6.svg";